<template>
  <div>
   
  <input id="box"  type="text">
    <button @click="ll()">还原</button>  

  </div>
</template>

<script>
// import inputArea from "../questionAnswer/components/inputArea/inputArea";
export default {
  data() {
    return {
      fileList: [
        { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },
        // Uploader 根据文件后缀来判断是否为图片文件
        // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
        { url: 'https://cloud-image', isImage: true }
      ]
    }
  },
  components:{
    // inputArea
  },
  methods:{
       afterRead(file) {
      // 此时可以自行将文件上传至服务器
    //   console.log(file);
    //alert(file.content)
    },
    ll(){
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
 .chat_wrapper {
  background: #f0f1f5;
  height: 100%;
  position: fixed;
  width: 100%;
  top: 0px;
}
#box{
  padding: 0.15rem 0;
    position: fixed;
    bottom: 0;
    z-index: 10;
    border:1px solid #ddd;
    width: 100%;
}
</style>